module.exports = __webpack_public_path__ + "static/icons/icono-mi-agente2.90312bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-mis-seguros/icono-mi-agente2.svg
// module id = Ee/I
// module chunks = 1